import { render, staticRenderFns } from "./AsignacionesView.vue?vue&type=template&id=d0e59842"
import script from "./AsignacionesView.vue?vue&type=script&lang=js"
export * from "./AsignacionesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports